export const branchStatus = {
  AT: "Active",
  IA: "Inactive",
  NA: "NA", // MORE THAN ONE WESS PROFIL
  "": "-",
};
